<div class="toolTip" tabindex="0">
  <img src="assets/img/icons/info.svg" alt="Tool Tip Bubble" />
  <div class="tooltiptext">
    <strong>{{ title }}</strong
    ><br />{{ message ?? "" }}
  </div>
</div>
